import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  [
    'group/badge inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden whitespace-nowrap',
    'rounded-4xl border border-transparent',
    'font-medium',
    'transition-all',
    'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
    'aria-invalid:border-error aria-invalid:ring-error/20 dark:aria-invalid:ring-error/40',
    '[&>svg]:pointer-events-none',
  ],
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground [a&]:hover:bg-primary/90',
        secondary: 'bg-muted [a&]:hover:bg-muted/40',
        destructive:
          'bg-error/10 text-error focus-visible:ring-error/20 dark:bg-error/20 dark:focus-visible:ring-error/40 [a&]:hover:bg-error/20 dark:[a&]:hover:bg-error/30',
        outline: 'border-border text-foreground [a&]:hover:bg-muted',
        ghost: 'hover:bg-muted hover:text-foreground dark:hover:bg-muted/70',
        link: 'text-primary underline-offset-4 hover:underline',
      },
      size: {
        default:
          'h-5 px-2 py-0.5 text-xs has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&>svg]:size-3!',
        sm: 'h-4 px-1 py-0 text-[10px] has-data-[icon=inline-end]:pr-1 has-data-[icon=inline-start]:pl-1 [&>svg]:size-2.5!',
        lg: 'h-6 px-2.5 py-1 text-sm has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2 [&>svg]:size-3.5!',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
